// Icon + text, never color alone (COMPONENTS.md → StatusBadge).
import { Calendar, CircleAlert, CircleCheck, CircleDot, CircleMinus, CirclePause, CircleX, Clock, Dot, Hourglass, type LucideIcon, Mail, Trash2 } from "lucide-react";
import semantics from "./status-semantics.json";

const ICONS: Record<string, LucideIcon> = {
  "circle-check": CircleCheck,
  calendar: Calendar,
  "circle-pause": CirclePause,
  clock: Clock,
  "circle-x": CircleX,
  "circle-minus": CircleMinus,
  mail: Mail,
  "trash-2": Trash2,
  hourglass: Hourglass,
  "circle-alert": CircleAlert,
  dot: Dot,
};

type Entry = { label: string; role: string; icon?: { lucide?: string } };
const STATUSES = semantics.statuses as Record<string, Entry>;

export function StatusBadge({ status, label }: { status: string; label?: string }) {
  // Enums can grow without a version bump: an unknown status renders generically.
  const entry = STATUSES[status] ?? { label: status.replaceAll("_", " "), role: "neutral" };
  const Icon = (entry.icon?.lucide && ICONS[entry.icon.lucide]) || CircleDot;
  return (
    <span className="badge" data-role={entry.role}>
      <Icon size={14} aria-hidden />
      <span>{label ?? entry.label}</span>
    </span>
  );
}
